import { getSalesNotificationTemplateIds } from './getSalesNotificationTemplateIds';
import { SALES_EXTENSION_CHANNEL, SALES_NOTIFICATION_RECEIVED_MESSAGE } from './constants';
import { getTemplateId } from '../../../worker/SalesExtension/GetTemplateId';
export const handleSalesNotification = ({
  id,
  template
}, isQa) => {
  const salesTemplateIds = getSalesNotificationTemplateIds(isQa);
  if (
  // eslint-disable-next-line hubspot-dev/no-confusing-browser-globals
  'BroadcastChannel' in self && salesTemplateIds.includes(getTemplateId(template))) {
    const broadcastChannel = new BroadcastChannel(SALES_EXTENSION_CHANNEL);
    broadcastChannel.postMessage({
      id,
      message: SALES_NOTIFICATION_RECEIVED_MESSAGE
    });
    broadcastChannel.close();
  }
};